import Vue from 'vue'
import App from './app.vue'
import router from '@router'
import { store } from './state/store'
import '@components/_globals'
import ApiService from './services/api.service'

ApiService.init()

ApiService.setHeader()

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

const appReleaseName = '#{APP_RELEASE_NAME}#'
const appReleaseBuildBranch = '#{APP_RELEASE_BUILD_BRANCH}#'
/* eslint-disable no-console */
console.log(
  `Tech App\nRelease Version: ${appReleaseName}\nBuild Branch:${appReleaseBuildBranch}`
)
/* eslint-enable no-console */

document.addEventListener(
  'touchstart',
  function addtouchclass(e) {
    // first time user touches the screen
    document.documentElement.classList.add('can-touch') // add "can-touch" class to document root using classList API
    document.removeEventListener('touchstart', addtouchclass, false) // de-register touchstart event
  },
  false
)
